module.exports = __webpack_public_path__ + "img/g3.6e996d5e.jpg";